// extracted by mini-css-extract-plugin
export default {"root":"h039vb1K","thin":"NGKaFgra","thick":"_BdnjPEa"};